/**
 * Do not edit directly
 * Generated on Wed, 17 Apr 2024 09:25:51 GMT
 */

export const SDS_SHADOW_ELEVATION_HIGH_Y = "0.75rem"; // Shadow vertical offset on high elevation level
export const SDS_SHADOW_ELEVATION_HIGH_BLUR = "1.5rem"; // Shadow blur radius on high elevation level
export const SDS_SHADOW_ELEVATION_MIDDLE_Y = "0.375rem"; // Shadow vertical offset on middle elevation level
export const SDS_SHADOW_ELEVATION_MIDDLE_BLUR = "0.75rem"; // Shadow blur radius on middle elevation level
export const SDS_SHADOW_ELEVATION_LOW_Y = "0.125rem"; // Shadow vertical offset on low elevation level
export const SDS_SHADOW_ELEVATION_LOW_BLUR = "0.25rem"; // Shadow blur radius on low elevation level
